import { ElementDirection } from '@fleet-beat/libs-core/src/lib/enums/element-direction.enum';

export interface TranslateLanguage {
  code: string;
  name: string;
  elementDirection: ElementDirection;
  isDefault?: boolean;
}
